<template>
  <v-flex sm10 offset-sm1>
    <v-container fluid pt-5 mt-5>
      <v-flex>
        <v-card class="elevation-0">
          <v-flex md12 class="mb-3">
            <v-tabs centered color="#dbeafeba" show-arrows dark  v-model="tab" >
              <v-toolbar-title lass="title">
                <div class="display-1 mt-3 mr-5 tamany_titol">{{ 'billing.title' | t }}</div>
              </v-toolbar-title>
              <v-tabs-slider color="primary ratlla"></v-tabs-slider>
            </v-tabs>
          </v-flex>
          <billing-list></billing-list>
        </v-card>
      </v-flex>
      <faqs></faqs>
    </v-container>
  </v-flex>
</template>

<script>
import BillingList from "@/components/BillingList";
import Faqs from "@/components/Faqs";

export default {
  components: {
    BillingList,
    Faqs
  }
};
</script>
<style scoped>
  .tamany_titol{
    color: #27408b !important;
    caret-color: #27408b !important;
    font-size: 28px !important;
    font-weight: 400;
    line-height: 20px !important;
    letter-spacing: normal !important;
    font-family: 'Roboto', sans-serif !important;
  }
  .ratlla{
    height: 3px !important;
  }
  .separa_tab{
    /*padding: 6px 20px !important;*/
    position: static !important;
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
  .clear_full {
    text-transform: none !important;    
  }
  .text_tab{
    font-size: 20px !important;
  }
  .color_digital {
    color :#80d484 !important;
  }
  .color_youtube {
    color :#e62117 !important;
  }
  .color_instagram {
    color :#ca41e2 !important;
  }
  .color_facebook {
    color :#4267b2 !important;
  }
  .color_twitter {
    color :rgb(8, 245, 253) !important;
  }
  .color_law {
    color :#e4d341 !important;
  }  
  .color_newspro {
    color :#476b63 !important;
  }
  </style>